import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { SentryService } from './app/core/common-services/sentry.service';

// Initialize Sentry before Angular bootstraps
// This ensures all errors are captured, including bootstrap errors
SentryService.initializeSentry();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
